import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { CalendarEvent } from "../../Calendars/Models/Domain";
import type { CalendarEventApi } from "../../Calendars/Models/Api";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";
import { snake } from "@/Utils/Snakelize";

const CalendarEventTransformer: TransformerExtended<CalendarEvent, CalendarEventApi> = {
  ...DefaultTransformerGenerator<CalendarEvent, CalendarEventApi>(),

  toDomain(input: CalendarEventApi): CalendarEvent {
    return camel(input);
  },

  toApi(input: CalendarEvent): CalendarEventApi {
    return snake(input);
  },
};

export type CalendarEventTransformerType = TransformerExtended<CalendarEvent, CalendarEventApi>;

export default CalendarEventTransformer;
